export function withViewOnlyHint(baseMessage: string, isViewOnly: boolean): string {
  return isViewOnly ? `${baseMessage}. Go active and try again.` : baseMessage;
}
